import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-signatures-table',
  templateUrl: './signatures.component.html',
  styleUrls: ['./signatures.component.scss'],
})
export class SignaturesComponent implements OnInit {

  signatures;
  @Input() firm;
  totalSignature = 0;

  constructor(private alertController: AlertController, private apiService: ApiService, private globalService: GlobalService) { }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    this.totalSignature = 0;
    let data: any = await this.apiService.get(`firms/${this.firm.guid}/signature_packs`);
    if (data.success) this.signatures = data.data;

    if (this.signatures) {


      this.signatures.forEach(sig => {
        this.totalSignature += sig.amount;

      });
    }

  }

  async presentAddSignatureAlert() {
    const alert = await this.alertController.create({
      header: 'Add a signature Pack',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => { return null; }
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: (data) => {
            this.CreateSignature(data);
          }
        }
      ],
      backdropDismiss: false,
      inputs: [
        {
          name: 'amount',
          label: 'Amount',
          placeholder: '0',
          id: 'focus-display-name',
          type: 'number'
        }
      ]
    });
    await alert.present();
    //Hack to focus on the first element when prompting
    const comentario: HTMLElement = document.querySelector("#focus-display-name");
    comentario.focus();
  }

  async CreateSignature(data) {
    await this.apiService.post(`firms/${this.firm.guid}/signature_packs`, data);
    this.GetData();
  }


  async presentDeleteSignaturePack(pack) {
    const alert = await this.alertController.create({
      header: 'Are you sure?',
      subHeader: `Delete Signature Pack`,
      message: `Are you sure you would like to the pack created on ${pack.created_date}`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Okay',
          handler: () => {
            //Delete the firm
            this.apiService.delete(`signature_packs/${pack.guid}`, null);
            this.globalService.RemoveFromArray(this.signatures, pack.guid);
          }
        }
      ]
    });
    await alert.present();

    const { role } = await alert.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);

  }

}
